import { Injectable, inject } from '@angular/core';
import { TranslationService } from '@waseel-asp/tpa-waseel-lib-staging';
@Injectable({
  providedIn: 'root'
})
export class TranslationLoaderService {
  private translation = inject(TranslationService);


  loadTranslations(): Promise<void> {
    return new Promise((resolve) => {
      this.translation.setDefaultLanguage(this.translation.getCurrentLanguage());
      this.translation.setLanguage(this.translation.getCurrentLanguage()).then(() => {
        resolve();
      });
    });
  }
}
